import { useState, useEffect } from 'react';
import { Menu, X, Phone, Instagram, Facebook, LogIn, Sparkles } from 'lucide-react';
import { Button } from '../componet/ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Inicio', href: '#inicio' },
    { name: 'Servicios', href: '#servicios' },
    { name: 'Clientes', href: '#clientes' },
    { name: 'Noticias', href: '#noticias' },
    { name: 'Herramientas', href: '#herramientas' },
    { name: 'Contacto', href: '#contacto' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 bg-blue-600 text p-4">
      <div className="flex justify-between items-center">
        <span className="font-bold text-xl">ROCKY</span>
        <ul className="flex gap-6">
          <li className="hover:underline cursor-pointer">Inicio</li>
          <li className="hover:underline cursor-pointer">Servicios</li>
          <li className="hover:underline cursor-pointer">Contacto</li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
